/**
 * Created by Andrey Popov on 3/15/21.
 */

const MinimalDialogue = cc.Node.extend({
    avoidNode: "MinimalDialogue",

    ctor: function (options) {
        this._super();
        this.options = options || {};
        this.targetRect = this.options.targetRect || this.options.rects && this.options.rects[0];
        this.setAnchorPoint(0.5, 0.5);
        this.setLocalZOrder(20);
        this._setGlobalZOrder(true);

        this.showUpDelay = this.options.delay !== undefined ? this.options.delay : 0.5;

        if (this.options.text) {
            this.items = [this.options.text];
        }

        if (this.options.items) {
            this.items = this.options.items;
        }
    },

    display: function () {
        this.createContent();
        this.updatePosition();

        if (MinimalDialogue.lastShown && MinimalDialogue.lastShown + 30000 > Date.now()) {
            this.options.shortAnimations = true;
        }
        MinimalDialogue.lastShown = Date.now();

        MinimalDialogue.current = this;
        this.addCleaner(() => {
            if (MinimalDialogue.current === this) {
                MinimalDialogue.current = undefined;
            }
        });

        this.showUp();

        if (connector.platform.oneOf(connector.CRAZY)) {
            connector.platform.gameplayStop();
            this.addCleaner(() => connector.platform.gameplayStart());
        }

        if (cleverapps.flags.debugMinimal && this.isDynamicPosition()) {
            MinimalDialogueDebug.create(this);
        }

        this.addCleaner(this.clearHideTimeout.bind(this));
        this.updateHideTimeout();
    },

    updateHideTimeout: function () {
        // A temporary spot is normally given up after overlapDuration; a persistent dialogue (a
        // tutorial step's force) keeps it until whoever displayed it takes it down.
        if (!this.temporaryPosition || this.options.persistent) {
            this.clearHideTimeout();
            return;
        }

        if (this.hideTimeout === undefined) {
            const duration = this.options.overlapDuration || 3;
            this.scheduleHideTimeout((this.showUpDelay + duration) * 1000);
        }
    },

    scheduleHideTimeout: function (timeout) {
        this.clearHideTimeout();
        this.hideTimeout = cleverapps.timeouts.setTimeout(() => this.hide(), timeout);
    },

    clearHideTimeout: function () {
        if (this.hideTimeout !== undefined) {
            cleverapps.timeouts.clearTimeout(this.hideTimeout);
            this.hideTimeout = undefined;
        }
    },

    onResize: function () {
        if (!this.shown) {
            return;
        }

        this.stopAllActions();
        this.createContent();
        this.updatePosition();
        this.updateHideTimeout();
    },

    updateTargets: function (rects) {
        this.options.rects = rects;
        this.targetRect = rects && rects[0];

        this.onResize();
    },

    updatePosition: function () {
        const styles = cleverapps.styles.MinimalDialogue;
        this.temporaryPosition = false;
        if (!this.calculatePosition()) {
            const maxDimensions = this.calcMaxDimensions();

            if (maxDimensions.width >= styles.text.minWidth) {
                this.createContent(maxDimensions);
                if (!this.calculatePosition()) {
                    this.defaultSlot();
                    this.temporaryPosition = true;
                }
            } else {
                this.defaultSlot();
                this.temporaryPosition = true;
            }
        }

        this.basePosition = this.getPosition();
    },

    updateOrientation: function () {
        const scene = cleverapps.Scenes.GetRunningScene();
        const styles = cleverapps.styles.MinimalDialogue;
        const isRight = this.x > scene.width / 2 + 3;

        if (styles.person.onBackground) {
            this.personNode.setAlignment({ align: "left", dx: styles.person.margin / 2 }, { align: "center" });
            this.bg.setAlignment({ align: "center" }, { align: "center" });
            return;
        }

        if (isRight) {
            this.personNode.setScaleX(-Math.abs(this.personNode.getScaleX()));
            this.personNode.setAlignment({ align: "right" }, { align: "center" });

            this.bg.setAnchorPoint(1, 0.5);
            this.bg.setAlignment({ align: "left" }, { align: "center" });
        } else {
            this.personNode.setScaleX(Math.abs(this.personNode.getScaleX()));
            this.personNode.setAlignment({ align: "left" }, { align: "center" });

            this.bg.setAnchorPoint(0, 0.5);
            this.bg.setAlignment({ align: "right" }, { align: "center" });
        }

        if (this.textBgArrow) {
            this.textBgArrow.setAlignment(isRight ? styles.text.arrow.right : styles.text.arrow.left);
            this.textBgArrow.setScaleX(isRight ? -1 : 1);
        }
    },

    removeContent: function () {
        if (this.options.items) {
            this.options.items.forEach((item) => {
                if (item.parent) {
                    item.removeFromParent(true);
                    item.setPosition(0, 0);
                }
            });
        }

        if (this.bg) {
            this.bg.removeAllChildren();
            this.bg.removeFromParent(true);
        }

        if (this.personNode) {
            this.personNode.removeFromParent();
            this.personNode = undefined;
        }

        delete this.personBackground;
        delete this.personAnimation;
        delete this.okButton;
        delete this.cancelButton;
        delete this.helpButton;
    },

    createContent: function (maxDimensions) {
        this.removeContent();

        const styles = cleverapps.styles.MinimalDialogue;

        const fixedHeight = styles.background && styles.background.height;
        const verticalScale = fixedHeight && cleverapps.resolution.isVertical() && styles.background.verticalScale || 1;

        const personNode = this.personNode = this.createPerson();
        const personSize = cc.size(personNode.width * personNode.scale + styles.person.margin, personNode.height * personNode.scale);

        const scene = cleverapps.Scenes.GetRunningScene();
        const availableRect = cc.rectSubPadding(scene.getBoundingBox(), cc.padding(styles.padding));
        availableRect.width = Math.min(availableRect.width, styles.maxWidth * verticalScale);

        const personOnBackground = styles.person.onBackground;

        const availableBgRect = cc.rect(
            availableRect.x,
            availableRect.y,
            availableRect.width - personSize.width,
            Math.min(availableRect.height, styles.text.maxHeight)
        );

        if (maxDimensions) {
            availableBgRect.width = Math.min(availableBgRect.width, maxDimensions.width);
            availableBgRect.height = Math.min(availableBgRect.height, maxDimensions.height);
        }

        if (fixedHeight) {
            availableBgRect.height = fixedHeight * verticalScale;
        }

        const textStyles = this.options.onHelp ? styles.text.withHelpButton : styles.text;
        const textPadding = cc.padding(cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL
            ? textStyles.verticalPadding : textStyles.padding);

        if (this.options.onHelp) {
            this.helpButton = this.createHelpButton();
        }

        const availableTextRect = cc.rectSubPadding(availableBgRect, textPadding);

        const items = this.items.map((item) => {
            if (typeof item === "string") {
                if (item.indexOf("<em>") !== -1) {
                    return this.createWrappedEmText(item, availableTextRect);
                }
                const font = cleverapps.resolution.resizeFont(cleverapps.styles.FONTS.FORCE_MESSAGE_TEXT);
                const text = cleverapps.UI.generateOnlyText(item, font);
                text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
                if (text.width > availableTextRect.width) {
                    text.setDimensions(availableTextRect.width, 0);
                }
                return text;
            }

            if (item.templateItems) {
                const dialogueLayout = this.createFromTemplate(item.templateItems, availableTextRect);
                cleverapps.UI.fitToBox(dialogueLayout, {
                    width: availableTextRect.width,
                    maxScale: item.scale
                });
                return dialogueLayout;
            }

            cleverapps.UI.fitToBox(item, {
                width: availableTextRect.width,
                maxScale: item.scale
            });

            return item;
        });

        const buttons = [];
        if (this.options.onCancel) {
            buttons.push(this.createCancelButton());
        }
        if (this.options.onOk) {
            buttons.push(this.createOkButton());
        }
        
        if (buttons.length > 0) {
            const buttonsLayout = new cleverapps.Layout(buttons, {
                direction: cleverapps.UI.HORIZONTAL,
                margin: styles.margin
            });
            cleverapps.UI.fitToBox(buttonsLayout, { width: availableTextRect.width });
            items.push(buttonsLayout);
        }

        const height = items.reduce((height, item) => height + item.height * item.scaleY, 0);

        if (height > availableTextRect.height) {
            items.forEach((item) => {
                const itemHeight = item.height * availableTextRect.height / height;
                if (item.fitTo) {
                    item.fitTo(availableTextRect.width, itemHeight);
                } else {
                    cleverapps.UI.fitToBox(item, {
                        width: availableTextRect.width,
                        height: itemHeight
                    });
                }
            });
        }

        this.contentItems = items;
        const direction = this.options.direction !== "undefined" ? this.options.direction : cleverapps.UI.VERTICAL;
        this.content = new cleverapps.Layout(items, {
            margin: styles.margin,
            direction
        });

        if (personOnBackground) {
            this.content = cleverapps.UI.wrapWithPadding(this.content, {
                x: Math.max(0, Math.min(
                    styles.text.minWidth * verticalScale - this.content.width,
                    availableTextRect.width - this.content.width
                ) / 2)
            });
        }

        const contentHeight = Math.max(this.content.height, styles.text.minHeight);
        const bgRect = cc.rectAddPadding(cc.rect(0, 0, this.content.width, contentHeight), textPadding);
        if (styles.person.fitBubbleHeight) {
            bgRect.height = Math.max(bgRect.height, personSize.height);
        }

        const bgImage = cleverapps.UI.createScale9Sprite(bundles.dialogues_minimal.frames.bg_minimal_png, cleverapps.UI.Scale9Rect.TwoPixelXY);

        const bg = this.bg = new cc.Node();
        bg.setAnchorPoint(0.5, 0.5);

        bgRect.height = fixedHeight * verticalScale || bgRect.height;
        bgRect.width = personOnBackground ? personSize.width + bgRect.width : bgRect.width;

        this.bg.setContentSize2(bgRect);

        bgImage.setScale(verticalScale);
        bgImage.setContentSize(bgRect.width / verticalScale, bgRect.height / verticalScale);

        bgImage.setAlignment(bgRect.width / 2, bgRect.height / 2);
        this.bg.addChild(bgImage);

        this.bg.addChild(this.content);

        if (styles.text.arrow) {
            this.textBgArrow = new cc.Sprite(bundles.dialogues_minimal.frames.mini_arrow_bg_png);
            this.bg.addChild(this.textBgArrow);
        }

        if (this.helpButton) {
            this.bg.addChild(this.helpButton);
            this.helpButton.setAlignment(styles.helpButton.position);
        }

        this.content.setAlignment(
            (personOnBackground ? personSize.width : 0) + textPadding.left + this.content.width / 2,
            (bgRect.height - textPadding.bottom - textPadding.top) / 2 + textPadding.bottom
        );

        this.bg.setCascadeOpacityEnabledRecursively(true);
        this.content.setCascadeOpacityEnabledRecursively(true);

        this.setContentSize2((personOnBackground ? 0 : personSize.width) + bgRect.width, Math.max(personSize.height, bgRect.height));

        this.addChild(this.bg);

        this.addChild(personNode);

        this.updateOrientation();
    },

    createOkButton: function () {
        this.okButton = this.createActionButton(this.options.onOk, this.options.okText || Messages.get("OK"));
        return this.okButton;
    },

    createCancelButton: function () {
        this.cancelButton = this.createActionButton(
            this.options.onCancel,
            this.options.cancelText || Messages.get("Cancel"),
            cleverapps.styles.UI.Button.Images.button_red
        );
        return this.cancelButton;
    },

    createActionButton: function (onClicked, text, type) {
        const styles = cleverapps.styles.MinimalDialogue.actionButton;
        const button = new cleverapps.UI.Button({
            text,
            type,
            width: styles.width,
            height: styles.height,
            onClicked
        });

        button.alwaysOn = true;
        this.scaleButton(button, styles);
        return button;
    },

    createHelpButton: function () {
        const button = new cleverapps.UI.HelpButton({
            callback: this.options.onHelp
        });

        button.alwaysOn = true;
        this.scaleButton(button, cleverapps.styles.MinimalDialogue.helpButton);
        return button;
    },

    scaleButton: function (button, styles) {
        if (cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL) {
            button.baseScale = styles.verticalScale;
            button.setScale(styles.verticalScale);
        }
    },

    createWrappedEmText: function (localized, availableTextRect) {
        const normalFont = cleverapps.resolution.resizeFont(cleverapps.styles.FONTS.FORCE_MESSAGE_TEXT);
        const emFont = cleverapps.resolution.resizeFont(cleverapps.styles.FONTS.MINIMAL_DIALOGUE_HIGHLIGHT_TEXT);
        const margin = Math.floor(normalFont.size * 0.25);

        const words = [];

        Messages.splitByEmTags(localized).forEach((part) => {
            const font = part.isEmphasized ? emFont : normalFont;
            part.text.split(/\s+/).filter(Boolean).forEach((word) => {
                const node = cleverapps.UI.generateOnlyText(word, font);
                node.debugLocalizationCode = part.code;
                if (words.length && [",", ".", "!", "?"].includes(word)) {
                    words[words.length - 1] = new cleverapps.Layout([words[words.length - 1], node], {
                        direction: cleverapps.UI.HORIZONTAL
                    });
                } else {
                    words.push(node);
                }
            });
        });

        const lines = [[]];
        let lineWidth = 0;
        words.forEach((node) => {
            const isFirst = lines[lines.length - 1].length === 0;
            const projected = lineWidth + (isFirst ? 0 : margin) + node.width;
            if (!isFirst && projected > availableTextRect.width) {
                lines.push([node]);
                lineWidth = node.width;
            } else {
                lines[lines.length - 1].push(node);
                lineWidth = projected;
            }
        });

        const rows = lines.map((line) => new cleverapps.Layout(line, {
            direction: cleverapps.UI.HORIZONTAL,
            margin
        }));

        return new cleverapps.Layout(rows, {
            direction: cleverapps.UI.VERTICAL,
            margin
        });
    },

    createPerson: function () {
        const personNode = new cc.Node();
        personNode.setAnchorPoint(0.5, 0.5);

        const personBackground = this.personBackground = new cleverapps.Spine(bundles.dialogues_minimal.jsons.bg_person);
        personBackground.setAlignment(personNode.width / 2, personNode.height / 2);
        personBackground.setAnimation(0, "minimal_idle", true);
        personNode.addChild(personBackground);

        let role = "hero";
        if (this.options.person && cleverapps.persons.getMinimalJson(this.options.person)) {
            role = cleverapps.skins.getSlot(this.options.person) || this.options.person;
        }
        const json = cleverapps.persons.getMinimalJson(role);

        this.personAnimation = new cleverapps.Spine(json);
        this.personAnimation.setAlignment(cleverapps.styles.MinimalDialogue.person);
        this.personAnimation.setAnimation(0, "talk_minimal", true);

        personBackground.addChild(this.personAnimation);
        cleverapps.UI.wrap(personNode);

        const skinSlot = `${role}_minimal`;
        const skin = cleverapps.skins.getSlot(skinSlot);
        if (skin) {
            this.personAnimation.setSkin(skin);
        }

        if (cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL) {
            personNode.setScale(0.6);
        }

        return personNode;
    },

    calculatePosition: function () {
        const sceneSize = cleverapps.resolution.getSceneSize();
        const styles = cleverapps.styles.MinimalDialogue;

        if (this.options.position) {
            if (this.options.position === MinimalDialogue.POSITIONS.TOP) {
                this.setAlignment(sceneSize.width / 2, sceneSize.height - this.height / 2 - styles.positions.top.y);
            } else if (this.options.position === MinimalDialogue.POSITIONS.TOP_LOWER) {
                this.setAlignment(sceneSize.width / 2, sceneSize.height - this.height / 2 - styles.positions.topLower.y);
            } else if (this.options.position === MinimalDialogue.POSITIONS.BOTTOM) {
                this.setAlignment(sceneSize.width / 2, this.height / 2 + styles.positions.bottom.y);
            } else if (this.options.position === MinimalDialogue.POSITIONS.CENTER) {
                this.setAlignment(sceneSize.width / 2, sceneSize.height / 2);
            } else if (this.options.position === MinimalDialogue.POSITIONS.CENTER_LEFT) {
                this.setAlignment(sceneSize.width - this.width / 2, sceneSize.height / 2);
            } else {
                this.setAlignment(typeof this.options.position === "function" ? this.options.position(this) : this.options.position);
            }
        } else if (this.isDynamicPosition()) {
            return this.calcDynamicPosition();
        } else {
            this.setAlignment(sceneSize.width / 2, this.height / 2 + styles.positions.bottom.y);
        }
        return true;
    },

    isDynamicPosition: function () {
        return this.options.rects && this.options.rects.length;
    },

    listRects: function () {
        const targetOffset = cleverapps.styles.MinimalDialogue.targetOffset;
        return this.options.rects.map(function (rect) {
            if (rect !== this.targetRect) {
                return rect;
            }
            return cc.rectAddPadding(rect, targetOffset);
        });
    },

    listAllPositions: function (rects) {
        const sceneSize = cleverapps.resolution.getSceneSize();
        const sceneBox = cc.rect(0, 0, sceneSize.width, sceneSize.height);
        const available = cc.rectSubPadding(sceneBox, cc.padding(this.height / 2, this.width / 2));

        const styles = cleverapps.styles.MinimalDialogue;
        const padding = cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL ? styles.rectsPaddingMobile : styles.rectsPadding;

        const positions = [];
        for (let i = 0; i < rects.length; i++) {
            const rect = rects[i];
            const slots = this.calcPositionSlots(rect, padding);

            for (let j = 0; j < slots.length; j++) {
                positions.push(cc.nearestToRect(available, slots[j]));
            }
        }

        return positions;
    },

    listDialogueRects: function () {
        const dialogueRects = [
            this.bg.getSceneBoundingBox()
        ];

        dialogueRects.unshift(this.personNode.getSceneBoundingBox());

        return dialogueRects;
    },

    calcIntersection: function (dialogueRects, rects) {
        let maxIntersectionArea = 0;
        let maxIntersectionRect;

        dialogueRects.forEach(function (dialogueRect) {
            rects.forEach((rect) => {
                const intersection = cc.rectIntersection(dialogueRect, rect);

                const area = intersection.width > 2 && intersection.height > 2 ? intersection.width * intersection.height : 0;
                if (area > maxIntersectionArea) {
                    maxIntersectionArea = area;
                    maxIntersectionRect = intersection;
                }
            }, this);
        }, this);

        if (maxIntersectionArea > 0) {
            return {
                area: maxIntersectionArea,
                rect: maxIntersectionRect
            };
        }
    },

    calcMaxDimensions: function () {
        const rects = this.listRects();
        const dialogueRect = this.listDialogueRects().reduce((dialogueRect, rect) => cc.rectUnion(dialogueRect, rect));

        const cumulative = cc.size();
        const center = cc.rectGetCenter(dialogueRect);

        rects.forEach((rect) => {
            const intersection = cc.rectIntersection(dialogueRect, rect);
            const intCenter = cc.rectGetCenter(intersection);

            let height = intersection.y - dialogueRect.y + intersection.height;
            if (intCenter.y > center.y) {
                height = dialogueRect.height - intersection.y - dialogueRect.y;
            }

            let width = intersection.x - dialogueRect.x + intersection.width;
            if (intCenter.x > center.x) {
                width = dialogueRect.width - intersection.x - dialogueRect.x;
            }

            cumulative.width = width > cumulative.width ? width : cumulative.width;
            cumulative.height = height > cumulative.height ? height : cumulative.height;
        });

        if (cumulative.width / dialogueRect.width < cumulative.height / dialogueRect.height) {
            cumulative.height = 0;
        } else {
            cumulative.width = 0;
        }

        return cc.size(
            dialogueRect.width - cumulative.width,
            dialogueRect.height - cumulative.height
        );
    },

    defaultSlot: function () {
        this.createContent();
        this.setAlignment(
            this.width / 2,
            cleverapps.resolution.getSceneSize().height * 2 / 3
        );
        this.updateOrientation();
    },

    pickVariant: function (variants) {
        let gravityPoint = cc.rectGetCenter(this.targetRect);
        const scene = cleverapps.Scenes.GetRunningScene();
        if (this.options.gravitate === MinimalDialogue.GRAVITATE.BOTTOM) {
            gravityPoint = cc.p(scene.width / 2, 0);
        } else if (this.options.gravitate === MinimalDialogue.GRAVITATE.TOP) {
            gravityPoint = cc.p(scene.width / 2, scene.height);
        }

        const validVariants = variants.filter((variant) => !variant.intersection);

        if (validVariants.length > 0) {
            return validVariants.sort((a, b) => cc.pDistance(a.position, gravityPoint) - cc.pDistance(b.position, gravityPoint))[0];
        }

        return false;
    },

    calcDynamicPosition: function () {
        const rects = this.listRects();

        let variants = [];

        this.listAllPositions(rects).forEach(function (position) {
            this.setAlignment(position);
            this.updateOrientation();

            const dialogueRects = this.listDialogueRects();

            variants.push({
                position,
                dialogueRects,
                intersection: this.calcIntersection(dialogueRects, rects)
            });
        }, this);

        const pickedVariant = this.pickVariant(variants);

        if (!pickedVariant) {
            variants = variants.sort((v1, v2) => (v1.intersection && v1.intersection.area || 0) - (v2.intersection && v2.intersection.area || 0));
            this.setAlignment(variants[0].position);
            return false;
        }

        this.pickedVariant = pickedVariant;
        this.variants = variants;

        this.updateOrientation();

        this.setAlignment(pickedVariant.position);
        return true;
    },

    calcPositionSlots: function (rect, padding) {
        const left = { x: rect.x - this.width / 2 - padding, y: rect.y + rect.height / 2 },
            right = { x: rect.x + rect.width + this.width / 2 + padding, y: rect.y + rect.height / 2 },
            up = { x: rect.x + rect.width / 2, y: rect.y + rect.height + this.height / 2 + padding },
            down = { x: rect.x + rect.width / 2, y: rect.y - this.height / 2 - padding };

        return [up, down, left, right];
    },

    showUp: function () {
        if (this.shown) {
            return;
        }
        this.shown = true;
        this.stopAllActions();
        this.bg.stopAllActions();
        this.content.stopAllActions();
        this.bg.setOpacity(0);
        this.bg.setScale(1);
        this.bg.setVisible(false);

        if (this.personAnimation) {
            this.personAnimation.setVisible(false);
            this.personBackground.setVisible(false);
        }

        this.runAction(new cc.Sequence(
            new cc.DelayTime(this.showUpDelay),
            new cc.Show(),
            new cc.CallFunc(() => {
                let showUpAnimation = "minimal_showup";

                if (this.options.shortAnimations) {
                    showUpAnimation = "minimal_short_showup";
                    this.fadeInShowUp();
                } else if (["wooden, heroes"].indexOf(cleverapps.config.ui) !== -1) {
                    this.bubbleShowUp();
                } else {
                    this.fadeInShowUp();
                }

                if (this.personAnimation) {
                    this.personAnimation.setVisible(true);
                    this.personAnimation.setAnimationAndIdleAfter(showUpAnimation, "talk_minimal");

                    this.personBackground.setVisible(true);
                    this.personBackground.setAnimationAndIdleAfter(showUpAnimation, "minimal_idle");
                }
            }),
            new cc.FireEffect("ui.minimaldialogue.show")
        ));
    },

    fadeInShowUp: function () {
        const styles = cleverapps.styles.MinimalDialogue;

        this.setPosition(this.basePosition.x, this.basePosition.y - styles.moveY);
        this.runAction(new cc.MoveTo(0.3, this.basePosition.x, this.basePosition.y).easing(cc.easeOut(2)));

        this.bg.setVisible(true);
        this.bg.runAction(new cc.FadeIn(0.3));
    },

    fadeOutHide: function () {
        const styles = cleverapps.styles.MinimalDialogue;

        this.runAction(new cc.MoveBy(0.3, 0, -styles.moveY).easing(cc.easeIn(2)));

        this.bg.runAction(new cc.Sequence(
            new cc.FadeOut(0.3),
            new cc.Hide()
        ));
    },

    bubbleShowUp: function () {
        this.bg.setScale(0.46);

        this.bg.runAction(new cc.Sequence(
            new cc.DelayTime(0.15),
            new cc.ScaleTo(0.3, 1.16, 1.26).easing(cc.easeIn(1)),
            new cc.ScaleTo(0.2, 1).easing(cc.easeOut(1))
        ));

        this.bg.runAction(new cc.Sequence(
            new cc.DelayTime(0.15),
            new cc.Show(),
            new cc.FadeIn(0.17)
        ));
    },

    bubbleHide: function () {
        this.bg.runAction(new cc.Sequence(
            new cc.DelayTime(0.13),
            new cc.ScaleTo(0.17, 1.16, 1.26).easing(cc.easeIn(1)),
            new cc.ScaleTo(0.17, 0).easing(cc.easeOut(1)),
            new cc.Hide()
        ));
    },

    hide: function (callback, silent) {
        this.clearHideTimeout();

        if (!this.shown) {
            callback && callback();
            return;
        }

        this.stopAllActions();
        this.bg.stopAllActions();
        this.content.stopAllActions();

        if (silent || !this.bg.isVisible()) {
            this.bg.setOpacity(0);
            this.bg.setVisible(false);

            this.personBackground && this.personBackground.setVisible(false);
            this.personAnimation && this.personAnimation.setVisible(false);

            this.shown = false;

            callback && callback();

            return;
        }

        if (this.options.shortAnimations) {
            this.fadeOutHide();

            if (this.personAnimation) {
                this.personAnimation.setAnimation(0, "minimal_short_hide", false);
                this.personBackground.setAnimation(0, "minimal_short_hide", false);
            }
        } else {
            this.bubbleHide();

            if (this.personAnimation) {
                this.personAnimation.setAnimation(0, "minimal_hide", false);
                this.personBackground.setAnimation(0, "minimal_hide", false);
            }
        }

        if (this.personAnimation) {
            this.personAnimation.setCompleteListenerOnce(() => {
                this.personAnimation.setVisible(false);
                this.personBackground.setVisible(false);
            });
        }

        this.runAction(new cc.DelayTime(0.6)).setFinalize(callback);

        this.shown = false;
    },

    remove: function (callback, silent) {
        this.hide(() => {
            this.removeFromParent();

            callback && callback();
        }, silent);
    },

    createFromTemplate: function (template, availableTextRect) {
        const styles = cleverapps.styles.MinimalDialogue;
        const dialogueLines = [];

        template.forEach((dialogueLine) => {
            const lineElements = [];

            dialogueLine.forEach((item) => {
                let element;

                if (item.text) {
                    const messageText = Messages.get(item.text);
                    const parts = Messages.splitByEmTags(messageText);

                    parts.forEach((part) => {
                        const chosenFont = part.isEmphasized ? cleverapps.styles.FONTS.MINIMAL_DIALOGUE_HIGHLIGHT_TEXT : cleverapps.styles.FONTS.FORCE_MESSAGE_TEXT;
                        const font = cleverapps.resolution.resizeFont(chosenFont);
                        const textElement = cleverapps.UI.generateOnlyText(part.text, font);
                        textElement.debugLocalizationCode = part.code;
                        textElement.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);

                        if (parts.length === 1 && textElement.width > availableTextRect.width) {
                            textElement.setDimensions(availableTextRect.width, 0);
                        }

                        lineElements.push(textElement);
                    });
                } else if (item.getIcon) {
                    element = item.getIcon();
                } else if (item.textWithIcon) {
                    const placeholders = {};
                    const icons = {};
                    const availableIcons = item.getIcons ? item.getIcons() : [];

                    if (availableIcons[0]) {
                        placeholders.icon1 = "[[";
                        icons["[["] = availableIcons[0];
                    }
                    if (availableIcons[1]) {
                        placeholders.icon2 = "]]";
                        icons["]]"] = availableIcons[1];
                    }

                    const message = Messages.get(item.textWithIcon, placeholders);
                    element = new TextWithIcon(message, {
                        font: item.highlight ? cleverapps.styles.FONTS.MINIMAL_DIALOGUE_HIGHLIGHT_TEXT : cleverapps.styles.FONTS.FORCE_MESSAGE_TEXT,
                        icons,
                        iconMaxHeight: 2
                    });
                }

                if (element) {
                    lineElements.push(element);
                }
            });

            const horizontalLayout = new cleverapps.Layout(lineElements, {
                direction: cleverapps.UI.HORIZONTAL,
                margin: styles.margin
            });

            dialogueLines.push(horizontalLayout);
        });

        return new cleverapps.Layout(dialogueLines, {
            direction: cleverapps.UI.VERTICAL
        });
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    MINIMAL_DIALOGUE_HIGHLIGHT_TEXT: {
        size: 50,
        color: new cc.Color(179, 113, 230, 255)
    }
});

cleverapps.styles.MinimalDialogue = {
    rectsPadding: 10,
    rectsPaddingMobile: 5,

    targetOffset: {
        left: 15, right: 20, top: 15, bottom: 25
    },

    maxWidth: 1000,
    margin: 10,

    moveY: 20,

    padding: {
        x: 10,
        y: 10
    },

    person: {
        x: { align: "center" },
        y: { align: "center" },
        margin: 10,
        // A one-line bubble is shorter than the person circle beside it; this keeps it at least as tall.
        fitBubbleHeight: false
    },

    actionButton: {
        width: 260,
        height: 80,
        verticalScale: 0.6
    },

    helpButton: {
        position: {
            x: { align: "left", dx: 20 },
            y: { align: "top", dy: -20 }
        },
        verticalScale: 0.6
    },

    text: {
        maxHeight: 450,
        minHeight: 90,
        minWidth: 300,
        padding: {
            top: 35,
            bottom: 35,
            left: 40,
            right: 40
        },
        verticalPadding: {
            top: 25,
            bottom: 25,
            left: 30,
            right: 30
        },

        withHelpButton: {
            padding: {
                top: 35,
                bottom: 35,
                left: 85,
                right: 85
            },
            verticalPadding: {
                top: 25,
                bottom: 25,
                left: 60,
                right: 60
            }
        }
    },

    positions: {
        topLower: {
            y: 200
        },
        top: {
            y: 100
        },
        bottom: {
            y: 20
        }
    }
};

MinimalDialogue.GRAVITATE = {
    BOTTOM: "bottom",
    TOP: "top"
};

MinimalDialogue.POSITIONS = {
    TOP: "top",
    TOP_LOWER: "top_lower",
    BOTTOM: "bottom",
    CENTER: "center",
    CENTER_LEFT: "center_left"
};